import { HashCode } from "../../utils";
export class Node {
  nodeId;
  type;
  childNode;
  title = "title";
  content = "content";
  conditionNodes;
  constructor({ id, type, isRow }) {
    if (type === "2") {
      this.title = "审批人";
    }else if(type === "4"){
      this.title = "抄送人";
    } else if(type === "5") {
      this.title = "办理人";
    }
    this.groupId = id;
    this.id = HashCode();
    this.type = type;
    // this.content += this.id;
    this.content = '请选择';
    this.isRow = isRow;
  }
}
export class ConditionNode {
  title = "title";
  data = [];
  constructor({ groupId, type, id, isRow }) {
    this.id = HashCode();
    this.groupId = groupId;
    this.type = type;
    this.content = "请设置条件";
    this.groupPid = id;
    this.isRow = isRow;
  }
}
export class RowNode extends Node {
  data = [];
  constructor({ id, type, isRow, title }) {
    super({ id, type, isRow, title });
  }
}
export class CopyNode {
  title = "标题";
  id = HashCode();
  content = "内容";
  data = [];
  constructor({ id, childNode, ...node }) {
    return Object.assign(node, this);
  }
}
